import * as React from "react";
const SvgEqualizer = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("g", { id: "equalizer_24px" }, /* @__PURE__ */ React.createElement("path", {
	id: "icon/av/equalizer_24px",
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M10.5 20H14.5V4H10.5V20ZM4.5 20H8.5V12H4.5V20ZM16.5 20V9H20.5V20H16.5Z",
	fill: "#6384E0"
})));
export default SvgEqualizer;
